import React, { useEffect } from 'react'

import { useFormikContext } from 'formik'

const AutoSubmitToken: React.FC = () => {
  // WARNING: using this component is NOT good for user experience when the target form
  // has value validation, as it will force submit without giving the user a chance to fix any error;
  const { dirty, values, submitForm } = useFormikContext()

  useEffect(() => {
    if (dirty) {
      submitForm()
    }
  }, [dirty, values, submitForm])
  return null
}

export default AutoSubmitToken
